<script setup>
import { ref } from 'vue'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

</script>

<template lang='pug'>
q-table(
  :rows-per-page-options="[]"
  bordered
  flat
  separator="cell"
  class="table"
  :no-data-label='t("table.nodata")'
  :loading-label='t("table.loading")'
  style="height: 90%"
)
  template(v-slot:header="props")
    q-tr(:class=`$q.dark.isActive ? 'bg-dark' : 'bg-white'`)
      slot(name="header" v-bind="props")

  template(v-slot:body="props")
    q-tr
      slot(name="body" v-bind="props")

  template(v-slot:no-data)
    slot(name="no-data")
      .full-width.row.flex-center.q-py-xl
        span.text-h6.text-grey {{ t("table.nodata") }}
</template>